import { render, staticRenderFns } from "./Focus.vue?vue&type=template&id=2d9271dc&scoped=true&"
import script from "./Focus.vue?vue&type=script&lang=js&"
export * from "./Focus.vue?vue&type=script&lang=js&"
import style0 from "./Focus.vue?vue&type=style&index=0&id=2d9271dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9271dc",
  null
  
)

export default component.exports